import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ui-form-section',
  templateUrl: './ui-form-section.component.html',
  styleUrls: ['./ui-form-section.component.scss']
})
export class UiFormSectionComponent {
  @Input() title = '';
  @Input() icon = '';
  @Input() showHeaderActions = false;
}
